import { Help } from "@/components/Help";
import { ReactNode, useEffect } from "react";
import styles from "@/pages/index.module.css";
import { Link } from "react-router";

export default function HelpPage(): ReactNode {
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  return (
    <div className={styles.modalPage}>
      <Link className={styles.modalPageBackdrop} to="/" />
      <Help />
    </div>
  );
}
